import { apiClient } from './client.tsx';
import { RemitSetting } from '../models/remit-setting.ts';

export const fetchRemitSettings = (siteProviderId: string) =>
  apiClient
    .get(
      `/maas_billing/site_provider_remit_settings?siteProviderId=${siteProviderId}`,
    )
    .then((res) => res.data.data);

export const createRemitSettings = (request: RemitSetting) =>
  apiClient
    .post(`/maas_billing/site_provider_remit_settings`, request)
    .then((res) => res.data.data);

export const updateRemitSettings = (request: RemitSetting) =>
  apiClient
    .patch(`/maas_billing/site_provider_remit_settings/${request.id}`, request)
    .then((res) => res.data.data);

export const voidRemitSettings = (id: string) =>
  apiClient
    .delete(`/maas_billing/site_provider_remit_settings/${id}`)
    .then((res) => res.data.data);

export const fetchRemitSettingStatuses = () =>
  apiClient
    .get('/maas_billing/site_provider_remit_settings/site_provider_statuses')
    .then((res) => res.data.data);
